import { ResponseIsCTSEmployee } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { IsCTSEmployeeActions } from '../actions';
import { IsCTSEmployeeTypes } from '../../shared/enums';

export interface IsCTSEmployeeState {
    response: ResponseIsCTSEmployee;
    error: any;
}

export const IsCTSEmployeeInitialState: IsCTSEmployeeState = {
    response: null,
    error: null
};

const _isCTSEmployeeReducer = createReducer(
    IsCTSEmployeeInitialState,

    on(IsCTSEmployeeActions.getIsCTSEmployee, (state) => ({
        ...state,
        error: null
    })),

    on(IsCTSEmployeeActions.getIsCTSEmployeeSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(IsCTSEmployeeActions.getIsCTSEmployeeError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(IsCTSEmployeeActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function isCTSEmployeeReducer(state, action) {
    if (action.type === IsCTSEmployeeTypes.IS_CTS_EMPLOYEE) {
        state = undefined;
    }
    return _isCTSEmployeeReducer(state, action);
}
